"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _uiThemeable = _interopRequireDefault(require("@instructure/ui-themeable"));

var _ThemeablePropTypes = _interopRequireDefault(require("@instructure/ui-themeable/lib/utils/ThemeablePropTypes"));

var _getElementType = _interopRequireDefault(require("@instructure/ui-utils/lib/react/getElementType"));

var _passthroughProps = require("@instructure/ui-utils/lib/react/passthroughProps");

var _deprecated = _interopRequireWildcard(require("@instructure/ui-utils/lib/react/deprecated"));

var _theme = _interopRequireDefault(require("./theme"));

var _dec, _class, _class2, _temp;

var styles = {
  componentId: 'dtYXf',
  template: function template(theme) {
    return "\n\n.dtYXf_cRbP{display:block}\n\n.dtYXf_eXrk{display:inline-block;vertical-align:middle}\n\n.dtYXf_crJo{box-sizing:border-box}\n\n.dtYXf_EMjX{text-align:start}\n\n[dir=ltr] .dtYXf_EMjX{text-align:left}\n\n[dir=rtl] .dtYXf_EMjX{text-align:right}\n\n.dtYXf_ImeN,[dir=ltr] .dtYXf_ImeN,[dir=rtl] .dtYXf_ImeN{text-align:center}\n\n.dtYXf_dBtH{text-align:end}\n\n[dir=ltr] .dtYXf_dBtH{text-align:right}\n\n[dir=rtl] .dtYXf_dBtH{text-align:left}\n\n.dtYXf_dfBC{max-width:".concat(theme.xSmallMaxWidth || 'inherit', "}\n\n.dtYXf_doqw{max-width:").concat(theme.smallMaxWidth || 'inherit', "}\n\n.dtYXf_ycrn{max-width:").concat(theme.mediumMaxWidth || 'inherit', "}\n\n.dtYXf_cMDj{max-width:").concat(theme.largeMaxWidth || 'inherit', "}\n\n.dtYXf_cMOR{max-width:100vw}\n\n.dtYXf_fFVr{outline:0.0625rem dashed red}\n\n.dtYXf_dnJm{border-color:").concat(theme.borderColor || 'inherit', ";border-radius:").concat(theme.borderRadius || 'inherit', ";border-style:solid;border-width:").concat(theme.borderWidth || 'inherit', "}\n\n.dtYXf_dGNy{box-shadow:").concat(theme.boxShadow || 'inherit', "}");
  },
  'block': 'dtYXf_cRbP',
  'inline': 'dtYXf_eXrk',
  'hasPadding': 'dtYXf_crJo',
  'textAlign--start': 'dtYXf_EMjX',
  'textAlign--center': 'dtYXf_ImeN',
  'textAlign--end': 'dtYXf_dBtH',
  'x-small': 'dtYXf_dfBC',
  'small': 'dtYXf_doqw',
  'medium': 'dtYXf_ycrn',
  'large': 'dtYXf_cMDj',
  'fullscreen': 'dtYXf_cMOR',
  'visualDebug': 'dtYXf_fFVr',
  'withBorder': 'dtYXf_dnJm',
  'withShadow': 'dtYXf_dGNy'
};

/**
---
category: components
---
**/
var Container = (_dec = (0, _uiThemeable.default)(_theme.default, styles), _dec(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Container, _Component);

  function Container() {
    (0, _classCallCheck2.default)(this, Container);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Container).apply(this, arguments));
  }

  (0, _createClass2.default)(Container, [{
    key: "renderSpacingStyles",
    value: function renderSpacingStyles(spacingFromProps, spacingFromTheme) {
      if (typeof spacingFromProps !== 'string') {
        return null;
      }

      var spacing = spacingFromProps.split(' ');
      var spacingStyle = [];

      for (var i = 0; i < spacing.length; i++) {
        var style = spacingFromTheme[spacing[i]];

        if (style) {
          spacingStyle.push(style);
        }
      }

      return spacingStyle.join(' ');
    }
  }, {
    key: "render",
    value: function render() {
      var _classes;

      var _this$props = this.props,
          children = _this$props.children,
          textAlign = _this$props.textAlign,
          display = _this$props.display,
          visualDebug = _this$props.visualDebug,
          size = _this$props.size,
          padding = _this$props.padding,
          margin = _this$props.margin,
          withBorder = _this$props.withBorder,
          withShadow = _this$props.withShadow;
      var classes = (_classes = {}, (0, _defineProperty2.default)(_classes, styles.root, true), (0, _defineProperty2.default)(_classes, styles[display], display !== null), (0, _defineProperty2.default)(_classes, styles.visualDebug, visualDebug), (0, _defineProperty2.default)(_classes, styles["textAlign--".concat(textAlign)], textAlign), (0, _defineProperty2.default)(_classes, styles[size], size), (0, _defineProperty2.default)(_classes, styles.hasPadding, padding), (0, _defineProperty2.default)(_classes, styles.withBorder, withBorder), (0, _defineProperty2.default)(_classes, styles.withShadow, withShadow), (0, _defineProperty2.default)(_classes, this.props.className, this.props.className), _classes);
      var style = (0, _objectSpread2.default)({}, this.props.style, {
        // eslint-disable-line react/prop-types
        margin: this.renderSpacingStyles(margin, this.marginFromTheme),
        padding: this.renderSpacingStyles(padding, this.paddingFromTheme)
      });
      var ElementType = (0, _getElementType.default)(Container, this.props);
      return _react.default.createElement(ElementType, Object.assign({}, (0, _passthroughProps.omitProps)(this.props, Container.propTypes), {
        className: (0, _classnames.default)(classes),
        style: style,
        ref: this.props.elementRef
      }), children);
    }
  }, {
    key: "paddingFromTheme",
    get: function get() {
      return {
        0: '0',
        none: '0',
        'xxx-small': this.theme.paddingxxxSmall,
        'xx-small': this.theme.paddingxxSmall,
        'x-small': this.theme.paddingxSmall,
        small: this.theme.paddingSmall,
        medium: this.theme.paddingMedium,
        large: this.theme.paddingLarge,
        'x-large': this.theme.paddingxLarge,
        'xx-large': this.theme.paddingxxLarge
      };
    }
  }, {
    key: "marginFromTheme",
    get: function get() {
      return {
        auto: 'auto',
        0: '0',
        none: '0',
        'xxx-small': this.theme.marginxxxSmall,
        'xx-small': this.theme.marginxxSmall,
        'x-small': this.theme.marginxSmall,
        small: this.theme.marginSmall,
        medium: this.theme.marginMedium,
        large: this.theme.marginLarge,
        'x-large': this.theme.marginxLarge,
        'xx-large': this.theme.marginxxLarge
      };
    }
  }]);
  Container.displayName = "Container";
  return Container;
}(_react.Component), _class2.propTypes = {
  as: _propTypes.default.elementType,
  // eslint-disable-line react/require-default-props
  children: _propTypes.default.node,
  textAlign: _propTypes.default.oneOf(['start', 'center', 'end']),

  /**
  * Controls the maximum width of the Container
  */
  size: _propTypes.default.oneOf(['auto', 'x-small', 'small', 'medium', 'large', 'fullscreen']),

  /**
  * Set the margin using familiar CSS shorthand
  */
  margin: _ThemeablePropTypes.default.spacing,

  /**
  * Set the padding using familiar CSS shorthand
  */
  padding: _ThemeablePropTypes.default.spacing,

  /**
  * By default the Container's display prop is null, meaning it takes on the
  * display rules of the html element it's rendered as.
  */
  display: _propTypes.default.oneOf([null, 'block', 'inline']),

  /**
  * Activate a dotted line around the Container to make building your
  * layout easier
  */
  visualDebug: _propTypes.default.bool,

  /**
  * provides a reference to the underlying html element
  */
  elementRef: _propTypes.default.func,

  /**
   * Whether or not to render a border around the Container
   */
  withBorder: _propTypes.default.bool,

  /**
   * Whether or not to render a box shadow for the Container
   */
  withShadow: _propTypes.default.bool
}, _class2.defaultProps = {
  display: void 0,
  withShadow: false,
  withBorder: false,
  visualDebug: false,
  padding: void 0,
  elementRef: void 0,
  margin: void 0,
  size: void 0,
  textAlign: void 0,
  children: null
}, _temp)) || _class);

var _default = (0, _deprecated.default)('5.4.0', null, "".concat((0, _deprecated.changedPackageWarning)('ui-container', 'ui-layout'), " It has also been renamed from [Container] to [View]."))(Container);

exports.default = _default;